import axios from "axios";
import aws4 from "aws4";
import {STS} from "aws-sdk";
import {getCredentials} from "src/api/Auth";
import {getApiEndpoint, getApiKey} from "src/api/ApiConfig";
import TemporaryCredentials from "src/model/TemporaryCredentials";
import GetItemCapturesRequest from "src/model/GetItemCapturesRequest";
import CanonicalRepresentationAPIRequest from "src/model/CanonicalRepresentationAPIRequest";

export async function getItemCaptures(region: string, inputData: GetItemCapturesRequest) {
    const apiRequestPath = '/prod/getItemCaptures'
    return await makeAPIRequest(region, apiRequestPath, inputData)
}

export async function getCanonicalRepresentation(region: string, inputData: CanonicalRepresentationAPIRequest) {
    const apiRequestPath = '/prod/getCanonicalRepresentation'
    return await makeAPIRequest(region, apiRequestPath, inputData);
}

async function makeAPIRequest(region: string,
                              apiRequestPath: string,
                              requestBody: {}) {
    try {
        const apiEndpoint: string = getApiEndpoint(region)!;
        const apiKey: string = getApiKey()!;
        const request = {
            host: apiEndpoint,
            method: 'POST',
            path: apiRequestPath,
            headers: {
                'Content-Type': 'application/json',
                'x-api-key': apiKey
            },
            body: JSON.stringify(requestBody)
        };

        const stsClient = new STS();
        const credentials: TemporaryCredentials = await getCredentials(stsClient);
        const signedRequest = aws4.sign(request, credentials);

        // Delete Host and Content-Length headers as axios does not recognize these headers
        delete signedRequest.headers['Host'];
        delete signedRequest.headers['Content-Length'];
        // Add additional attributes required for axios to make API call
        signedRequest.url = `https://${apiEndpoint}${apiRequestPath}`;
        signedRequest.data = signedRequest.body;

        console.log('Invoking Image Gallery API...');
        const response = await axios.request(signedRequest);
        return response.data;
    }
    catch (e) {
        console.error('Error while retrieving captures for Item: ', e);
        throw e;
    }
}